/* @flow */
const prefix = str => `station/enclave-management/${str}`;

export const FETCH = prefix('FETCH');
export const FETCH_SUCCESS = prefix('FETCH_SUCCESS');
export const FETCH_FAILURE = prefix('FETCH_FAILURE');

export const SAVE = prefix('SAVE');
export const SAVE_SUCCESS = prefix('SAVE_SUCCESS');
export const SAVE_FAILURE = prefix('SAVE_FAILURE');

export const DELETE = prefix('DELETE');
export const DELETE_SUCCESS = prefix('DELETE_SUCCESS');
export const DELETE_FAILURE = prefix('DELETE_FAILURE');

export const SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');

// These actions are for querying the enclave map, the original enclave map was too coupled with everything to query without side effects
// This was the best safe solution in the time alotted
export const FETCH_WITH_QUERY = prefix('FETCH_WITH_QUERY');
export const FETCH_WITH_QUERY_SUCCESS = prefix('FETCH_WITH_QUERY_SUCCESS');
export const FETCH_WITH_QUERY_FAILURE = prefix('FETCH_WITH_QUERY_FAILURE');
export const SET_QUERY_RESULTS = prefix('SET_QUERY_RESULTS');



// WEBPACK FOOTER //
// ./src/app/modules/enclave-management/action-types.js